import '/assets/styles/pages/smf/line-up.scss';

const SMFLineup = () => {
	return (
		<div className="wysiwyg wrapper">
			<ul className="lineup-list no-list">
				<li>
					<h2>4 Ağustos 2023 - Cuma</h2>

					<ul>
						<li>
							<strong>Pinhani - 22:00</strong>
						</li>
						<li>
							<strong>Fatma Turgut - 20:15</strong>
						</li>
						<li>
							<strong>Ozbi - 18:45</strong>
						</li>
						<li>
							<strong>Kendimden Hallice - 17:30</strong>
						</li>
						<li>
							<strong>Popeye - 16:00</strong>
						</li>
					</ul>
				</li>

				<li>
					<h2>5 Ağustos 2023 - Cumartesi</h2>

					<ul>
						<li>
							<strong>Mor ve Ötesi - 22:00</strong>
						</li>
						<li>
							<strong>Hey Douglas - 20:15</strong>
						</li>
						<li>
							<strong>The Away Days - 18:45</strong>
						</li>
						<li>
							<strong>Hayki - 17:30</strong>
						</li>
						<li>
							<strong>Popeye - 16:15</strong>
						</li>
					</ul>
				</li>

				<li>
					<h2>6 Ağustos 2023 - Pazar</h2>

					<ul>
						<li>
							<strong>Manga - 22:00</strong>
						</li>
						<li>
							<strong>Yeni Türkü - 20:15</strong>
						</li>
						<li>
							<strong>Sena Şener - 18:45</strong>
						</li>
						<li>
							<strong>Hedonutopia - 17:30</strong>
						</li>
						<li>
							<strong>Bizimkiler - 16:15</strong>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	);
};

export default SMFLineup;
